import { TemplateFormDialogContentsSectionForm } from "../types";
import { CarePlanFormsSection } from "./CarePlanFormsSection";
import { CarePlanFilesSection } from "./CarePlanFilesSection";
import { CarePlanContentSection } from "./CarePlanContentSection";
import { CarePlanTasksSection } from "./CarePlanTasksSection";
import { useTranslation } from "react-i18next";

export interface CarePlanSectionProps {
  form: TemplateFormDialogContentsSectionForm<"carePlanForms" | "carePlanFiles" | "carePlanContent" | "carePlanTasks">;
}

export const CarePlanSection = ({ form }: CarePlanSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <section className="space-y-6">
      <CarePlanFormsSection form={form} />
      <CarePlanFilesSection form={form} />
      <CarePlanContentSection form={form} />
      <CarePlanTasksSection form={form} />
      <p className="text-xs text-muted-foreground font-light">
        {t("Care plan items will be automatically assigned when this template is used for appointments.")}
      </p>
    </section>
  );
};
